import { ReactNode } from "react";
import { GuestIcon } from "./Icons";
import { BronzeIcon } from "./Icons/BronzeIcon";
import { GoldIcon } from "./Icons/GoldIcon";
import { PlatinumIcon } from "./Icons/PlatinumIcon";
import { TitaniumIcon } from "./Icons/TitaniumIcon";
import { PlanCard } from "./PlanCard";
import { useContent } from "../../i18n";
import "./style.scss";

// No prices or percentages here: every organisation plan's benefits, services and balance come from the sponsor.
export const Plans = () => {
  const { plans } = useContent();
  const corporate = (tier: { name: string; d: string }, icon: ReactNode) => ({
    name: tier.name,
    tag: plans.corporateTag,
    description: `${tier.d} ${plans.corporateDetail}`,
    icon,
  });

  const plansList = [
    corporate(plans.platinum, <PlatinumIcon />),
    corporate(plans.titanium, <TitaniumIcon />),
    corporate(plans.gold, <GoldIcon />),
    corporate(plans.bronze, <BronzeIcon />),
    {
      name: plans.guest.name,
      tag: plans.guest.tag,
      description: plans.guest.d,
      icon: <GuestIcon />,
    },
  ];

  return (
    <div id="plans" className="plans-wrapper">
      <div className="container">
        <h2>{plans.title}</h2>
        <p className="plans-note">{plans.note}</p>
        <div className="plan-card-container">
          {plansList.map((plan) => (
            <PlanCard plan={plan} key={plan.name} />
          ))}
        </div>
      </div>
    </div>
  );
};
